module.exports = __webpack_public_path__ + "ins07.png?2321915dcd9cc91924a3bbfa754c78e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins07.png
// module id = 158
// module chunks = 0